module.exports = __webpack_public_path__ + "img/right_bg.9b66ea6.png";